import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const saveClaim = createProvider(api.saveClaim).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Save claim aborted');
  } else {
    console.error('Save claim was failed:', error);
  }
  throw error;
});
